import React, { useEffect, useMemo, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import {
	EnvelopesWrapper,
	NavigationWrapper,
	PickerHOC,
	TargetsWrapper,
	Text,
	UiWrapper,
	View,
} from '@coinscrap/webapp-core';

import { Wrapper } from 'layout/components/Body/Wrapper';
import Footer from 'layout/components/Footer/Footer';
import Header from 'layout/components/Header/Header';

import { DocuSign } from 'components/DocuSign/DocuSign';
import { MainModal } from 'components/MainModal/MainModal';

import { useGetError } from 'hooks/useGetError';
import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import { DebugContext } from '../../App';
import { useCoinscrapPageView } from '../../hooks/useCoinscrapPageView';
import * as S from './styles';

/* eslint-disable no-console */
// eslint-disable-next-line react/prop-types
export const SignatureContract = PickerHOC({
	target: {
		arrayItemMatcher: {
			type: 'param',
			paramName: 'targetId',
			itemPropertyPath: 'id',
		},
		sourcePath: 'targets',
		sourceWrapper: TargetsWrapper,
	},
	envelope: {
		sourcePath: 'envelopes',
		sourceWrapper: EnvelopesWrapper,
		arrayItemMatcher: {
			type: 'param',
			paramName: 'envelopeId',
			itemPropertyPath: 'id',
		},
	},
})(() => {
	const { refresh, getSignUrl } = EnvelopesWrapper.use();
	const [docuSignUrl, setDocuSignUrl] = useState(null);
	const { navigateTo, params } = NavigationWrapper.use();
	const { loadTargets } = TargetsWrapper.use();
	const { useHeader, useFooter, useLoading, openModal } = UiWrapper.use();
	const { target, envelope } = PickerHOC.use();
	const { t, i18n } = useTranslation();

	const isDebug = React.useContext(DebugContext);

	const [loading, setLoading] = useState();

	useFooter(<Footer />, []);
	useHeader(<Header />, []);
	useLoading(!docuSignUrl || loading, { loadingMessage: loading });
	useInitialScrollToTop();
	useCoinscrapPageView('SignatureContract');
	const getError = useGetError();

	// TARGET CREATION DATA
	const creationData = useMemo(
		() => target?.targetProperties?.find((x) => x.name === 'creationData')?.value,
		[target],
	);

	// ESTADO
	const [renders, setRenders] = useState(0);
	const isB2B = useMemo(() => creationData?.details?.isB2B || false, [creationData]);
	const [finished, setFinished] = useState(false);

	// NAVIGATION
	const next = async () => {
		console.log('envelope?.signStatus', envelope?.signStatus);
		console.log('target.status', target.status);
		if (envelope?.signStatus === 'SIGNED' && isDebug) {
			// Para poder llegar al final del proceso sin tener en cuenta los problemas de indexación de documentos en el entorno dev
			CONFIG.routing.signatureContract.next(navigateTo);
		} else {
			envelope?.signStatus === 'SIGNED' && target.status === 'ACTIVE'
				? CONFIG.routing.signatureContract.next(navigateTo)
				: CONFIG.routing.signatureContract.ko(navigateTo);
		}
	};

	// EFFECTS
	useEffect(() => {
		console.log('📌 creationData', creationData);
		console.log('📌 target', target);
		console.log('📌 envelope', envelope);
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (finished) {
			next();
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [finished]);

	useEffect(() => {
		if (docuSignUrl === null) {
			const signUrl = getSignUrl(envelope.id);
			setDocuSignUrl(signUrl);
			console.log('💢 SIGN URL', signUrl);
		}
		return () => {};
	}, [getSignUrl, target.id, envelope, docuSignUrl]);

	return docuSignUrl ? (
		<Wrapper showTopSection step={6} title="Documentos y firma">
			<View innerWrapperSt>
				{/* <S.StepWrapper>
					<S.StepWrapperItem>
						<S.StepCircle>4</S.StepCircle>
						<Text stepsSt>{t('signatureSteps.feature3')}</Text>
					</S.StepWrapperItem>
				</S.StepWrapper> */}
				{docuSignUrl && (
					<DocuSign
						url={docuSignUrl}
						onProcessFinished={async () => {
							setLoading('Actualizando Datos');
							try {
								await refresh();
							} catch (e) {
								setLoading(undefined);
								openModal(() => <MainModal type="error" text={getError(e)} />, {
									disableClickAway: true,
									closeButton: true,
									modalClass: isMobile ? 'modal-xl' : 'modal-main',
									key: 'modal-SignatureContract-KO',
								});
							}
							try {
								await loadTargets([target.id]);
							} catch (e) {
								console.log('❌ ERROR', e);
							}
							setLoading(undefined);
							setFinished(true);
						}}
					></DocuSign>
				)}
			</View>
		</Wrapper>
	) : null;
});
